const AVATAR_COLORS = [
  "#0972d3",
  "#7b2cf5",
  "#d63384",
  "#e07a2f",
  "#037f0c",
  "#1a8a8a",
  "#5f6b7a",
  "#b44d12",
]

/**
 * Get a deterministic color for an avatar based on a string identifier. Hashes the ID to
 * consistently map to one of the predefined colors.
 */
export function getAvatarColor(id: string): string {
  let hash = 0
  for (const ch of id) {
    hash = (hash * 31 + ch.charCodeAt(0)) | 0
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length]
}

/**
 * Extract up to 2 initials from a display name. Splits on spaces and takes the first character of
 * each word.
 */
export function getInitials(name: string): string {
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2)
}
